import { createSelector } from 'reselect';

export const getWorksIsLoading = state => state.works.isLoading;
export const getWorksPagination = state => state.works.pagination;

export const moreWorksToGet = state =>
  state.works.pagination
    ? state.works.pagination.current_page < state.works.pagination.total_pages
    : true;

const getIds = state => state.works.data;
const getResult = state => state.entities.works;
const getCategories = state => state.entities.categories;
export const getAllWorks = (state, slug = null) =>
  createSelector(
    getIds,
    getResult,
    getCategories,
    (ids, result, categories) => {
      return ids
        .map(id => {
          let work = Object.assign({}, result[id]);

          if (categories[work.category_id]) {
            work.category = categories[work.category_id];
          }

          return work;
        })
        .filter(work => {
          if (!slug) return true;

          return work.category.slug === slug;
        })
        .sort((a, b) => {
          let fieldA = a.date;
          let fieldB = b.date;

          if (fieldA < fieldB) {
            return 1;
          }
          if (fieldA > fieldB) {
            return -1;
          }

          return 0;
        });
    }
  )(state);

export const getOrderedWorks = (state, slug = null) =>
  createSelector(
    getIds,
    getResult,
    getCategories,
    (ids, result, categories) => {
      return ids
        .map(id => {
          let work = Object.assign({}, result[id]);

          if (categories[work.category_id]) {
            work.category = categories[work.category_id];
          }

          return work;
        })
        .filter(work => {
          if (!slug) return true;

          return work.category.slug === slug;
        })
        .sort((a, b) => {
          let fieldA = a.num;
          let fieldB = b.num;

          if (fieldA < fieldB) {
            return 1;
          }
          if (fieldA > fieldB) {
            return -1;
          }

          return 0;
        });
    }
  )(state);

const getPhotos = state => state.entities.work_photos;
export const getWork = (state, workId) =>
  createSelector(
    getResult,
    getCategories,
    getPhotos,
    (works, categories, photos) => {
      let work = Object.assign({}, works[workId]);

      if (categories[work.category_id]) {
        work.category = categories[work.category_id];
      }

      if (work.work_photos) {
        work.work_photos = work.work_photos.map(photo => {
          return photos[photo];
        });
      } else {
        work.work_photos = [];
      }

      return work;
    }
  )(state);



// WEBPACK FOOTER //
// ./src/redux/selectors/works.js